import { VizType } from "@atlas-int/data";
import { StandardControlPanel } from "./StandardControlPanel";
import { SpecializedVisualizationControlPanel } from "./SpecializedVisualizationControlPanel";

interface ControlPanelRouterProps {
  vizType: VizType;
  isSettingsOpen: boolean;
  toggleSettingsPanel: () => void;
}

export const ControlPanelRouter = ({
  vizType,
  isSettingsOpen,
  toggleSettingsPanel,
}: ControlPanelRouterProps) => {
  switch (vizType) {
    case VizType.MarketShare:
    case VizType.Feasibility:
    case VizType.ProductSpace:
      return (
        <SpecializedVisualizationControlPanel
          vizType={vizType}
          isSettingsOpen={isSettingsOpen}
          toggleSettingsPanel={toggleSettingsPanel}
        />
      );

    default:
      return (
        <StandardControlPanel
          vizType={vizType}
          isSettingsOpen={isSettingsOpen}
          toggleSettingsPanel={toggleSettingsPanel}
        />
      );
  }
};
